var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_2363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3937 3.42799C61.3937 3.42799 40.6608 -1.06747 29.9004 3.37592C29.9004 3.37592 4.35437 4.41734 1.56689 23.8919C1.56689 23.8919 8.81259 36.7881 13.3574 37.5866C17.9022 38.3763 16.621 42.299 16.621 42.299L21.1138 51.2465L22.8971 71.2244L16.621 68.8899L13.6084 69.8272L13.998 83.8517L16.0063 86.2556L37.3366 87.8611L40.6694 83.843H48.296L52.2175 86.516L71.1585 86.2209L75.6686 75.1992L76.4218 67.1976L77.8675 63.8304L78.3955 50.3787H73.9979L70.5006 56.3408L67.8429 58.7795V50.37L72.3704 39.6434L88.117 23.5708C88.117 23.5708 82.6806 6.11833 61.3764 3.41063L61.3937 3.42799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1138 51.2465C21.1138 51.2465 21.3562 86.5159 30.5323 86.5246C31.9607 86.5246 36.0986 86.5246 36.7479 86.5246C40.0201 86.5593 40.6694 84.0252 40.6694 80.6927V60.4197",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0141 73.1858C22.0141 73.1858 17.98 68.9681 17.9714 68.9594C16.5343 67.458 14.2576 67.7965 13.6084 69.8186C13.2188 71.0335 13.3919 76.9523 13.3833 78.4971C13.3573 81.2395 13.2881 84.572 16.0063 86.2556C16.9412 86.8284 19.417 86.6809 21.0272 86.6809C24.0484 86.6809 27.0783 86.6809 30.0995 86.6809",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9653 86.1688C59.4805 86.4032 58.9784 86.5247 58.4331 86.5247C57.0047 86.5247 52.8668 86.5247 52.2175 86.5247C48.9453 86.5594 48.296 84.0253 48.296 80.6927V60.4197",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8516 51.2465C67.8516 51.2465 67.7737 63.1881 65.8951 73.1684",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4101 74.8C67.4101 74.8 61.9737 68.9681 61.965 68.9594C60.528 67.458 58.2513 67.7965 57.602 69.8185C57.2125 71.0335 57.3856 76.9523 57.3769 78.497C57.351 81.2395 57.2817 84.572 59.9999 86.2556C60.9349 86.8284 63.4107 86.6809 65.0209 86.6809C66.051 86.6809 67.0812 86.6809 68.1113 86.6809C68.6047 86.6809 69.0982 86.6982 69.5916 86.6809C71.6346 86.6201 72.734 84.8237 73.4871 83.1661C75.5994 78.4884 75.9716 72.4308 75.4782 67.2931C75.0281 62.6761 72.8379 56.2888 68.3018 55.4122",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1584 55.9156C71.1584 55.9156 72.4916 55.1692 73.2101 52.4789C73.9373 49.7538 77.8328 49.6844 78.6292 52.3834C79.668 55.9156 79.6074 60.8016 76.4218 67.2063",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6694 83.843H48.296",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5043 1.36252C44.5043 1.36252 34.324 0.755027 29.9004 3.37593C29.4935 3.61893 28.0998 3.38461 27.615 3.42801C25.5547 3.58422 23.5203 4.00079 21.5466 4.5996C14.6212 6.68244 8.59612 11.0564 3.91282 16.5152C1.17729 19.7089 0.0865371 23.1022 3.15968 26.5649L6.7782 30.9736C9.47045 34.2454 15.3484 42.1428 20.049 36.8489C20.049 36.8489 25.5114 32.015 28.0045 23.944",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.621 39.6608C16.621 39.6608 17.6252 53.1645 32.307 55.1866",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6446 35.2607C34.2654 35.2607 35.5792 33.9436 35.5792 32.3187C35.5792 30.6939 34.2654 29.3767 32.6446 29.3767C31.0238 29.3767 29.71 30.6939 29.71 32.3187C29.71 33.9436 31.0238 35.2607 32.6446 35.2607Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4309 39.7996L41.1888 37.5519C40.3491 36.7101 40.9464 35.2607 42.1323 35.2607H46.8589C48.0536 35.2607 48.6509 36.7101 47.8025 37.5519L45.5604 39.7996C44.9718 40.3897 44.0109 40.3897 43.4222 39.7996H43.4309Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3365 42.6809C37.3365 42.6809 39.8643 47.376 44.0801 44.1909V40.6241",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5043 1.36252C44.5043 1.36252 54.6846 0.755027 59.1082 3.37593C59.5151 3.61893 60.9088 3.38461 61.3936 3.42801C63.4539 3.58422 65.4882 4.00079 67.462 4.5996C74.3874 6.68244 80.4125 11.0564 85.0958 16.5152C87.8313 19.7089 88.922 23.1022 85.8489 26.5649C84.6456 28.0316 83.4337 29.5069 82.2304 30.9736C79.5381 34.2454 73.6602 42.1428 68.9596 36.8489C68.9596 36.8489 63.4972 32.015 61.004 23.944",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.379 39.6608C72.379 39.6608 71.3748 53.1645 56.693 55.1866",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3641 35.2607C57.9848 35.2607 59.2987 33.9436 59.2987 32.3187C59.2987 30.6939 57.9848 29.3767 56.3641 29.3767C54.7433 29.3767 53.4294 30.6939 53.4294 32.3187C53.4294 33.9436 54.7433 35.2607 56.3641 35.2607Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6721 42.6809C51.6721 42.6809 49.1443 47.376 44.9285 44.1909V40.6241",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_2363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedLogo);
export default __webpack_public_path__ + "static/media/icon-feed-logo.0acecb5655b6d7d249ac5407ed56d056.svg";
export { ForwardRef as ReactComponent };